/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terms_Exported_CsvInputs */



/**
* | output |
* | --- |
* | "Terms exported to CSV" |
*
* @param {Knp_Terms_Exported_CsvInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_exported_csv = /** @type {((inputs?: Knp_Terms_Exported_CsvInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Exported_CsvInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Termes exportés en CSV")
	if (locale === "de") return /** @type {LocalizedString} */ ("Begriffe in CSV exportiert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Termini esportati in CSV")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Термины экспортированы в CSV")
	if (locale === "es") return /** @type {LocalizedString} */ ("Términos exportados a CSV")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出到 CSV 的术语")
	if (locale === "ja") return /** @type {LocalizedString} */ ("CSVにエクスポートされた用語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("CSV में निर्यात की गई शर्तें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Termos exportados para CSV")
	return /** @type {LocalizedString} */ ("Terms exported to CSV")
});